module.exports = __webpack_public_path__ + "img/008-procedure.791d7098.svg";